import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '@app/shared/button/button.component';
import { MessageComponent, TypeMessage } from '@app/shared/message/message.component';
import { NgxMaskModule } from 'ngx-mask';
import { TypeStep } from '../sign-up.component';
import { AuthService } from '@modules/auth/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonComponent, NgxMaskModule, MessageComponent],
})
export class AuthorizationComponent implements OnInit {
  authorizationForm: FormGroup;
  isShowPassword = false;
  errorObject: { isError: boolean; type: TypeMessage; message: string } = {
    isError: false,
    type: 'error',
    message: 'Неверный логин или пароль',
  };
  isSendCredentials = false;
  @Input() phone: string;
  @Output() changeStep = new EventEmitter<TypeStep>();

  constructor(private _authService: AuthService) {}
  ngOnInit(): void {
    this.authorizationForm = new FormGroup({
      login: new FormControl<string>(this.phone, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
      password: new FormControl<string>(null, [Validators.required]),
    });

    this.authorizationForm.get('password').valueChanges.subscribe(() => {
      if (this.errorObject.isError) {
        this.errorObject.isError = false;
      }
    });

    this.authorizationForm.get('login').valueChanges.subscribe(() => {
      if (this.errorObject.isError) {
        this.errorObject.isError = false;
      }
    });
  }

  confirmCredentials() {
    this.isSendCredentials = true;
    this._authService.login({ login: this.phone, password: this.authorizationForm.get('password').value }).subscribe(
      (res) => {
        this.isSendCredentials = false;
        this.changeStep.emit('closeAll');
      },
      (err) => {
        this.isSendCredentials = false;
        this.errorObject.isError = true;
      },
    );
  }

  changeStepEvent(step: TypeStep) {
    this.changeStep.emit(step);
  }
}
